import React, { useEffect, useMemo, useRef, useState } from 'react';
import MapView from '@arcgis/core/views/MapView';
import Map from '@arcgis/core/Map';
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
import GroupLayer from '@arcgis/core/layers/GroupLayer';
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Home from "@arcgis/core/widgets/Home";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Expand from "@arcgis/core/widgets/Expand.js";
import Graphic from "@arcgis/core/Graphic.js";
import Locate from "@arcgis/core/widgets/Locate.js";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Table from './Table';
import { setSelectedBuffer } from "../store/slice/bufferSlice";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const mainLayerUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";



const MapAiComponent = ({ selectedLayer, onViewReady, isWidth, isScreenSize, isByDefaultActive, locationAi }) => {
  const mapRef = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation()
  const [view, setView] = useState(null);
  const [isDrag, setIsDrag] = useState(false);
  const [isAccordian, setIsAccordian] = useState('');
  const [tabLocation, setTabLocation] = useState(false);
  const [isLayerListExpanded, setIsLayerListExpanded] = useState(false);
  const currentStageValue = useSelector((state) => state.currentStage.features)
  const { bufferData, selectedBuffer, setFeatureTable } = useSelector((state) => state.buffer);
  const features = bufferData[selectedBuffer] || [];
  const [isScreenSize1, setIsScreenSize1] = useState(window.innerWidth <= 991);


  const handleDrag = () => {
    setIsDrag(!isDrag)
  }

  // Layer URLs and titles
  const layerUrls = [
    //Admin Boundary
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/1", title: "MP State" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/2", title: "MP Division" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3", title: "MP District" },    
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5", title: "MP Municipal Area" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/7", title: "Municipal Ward Boundary" },    
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/94", title: "MP ULB" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/95", title: "MP Ward" },


    //Property
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/14", title: "MP Property" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/15", title: "MP Plot Building Structure" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/79", title: "Important Land Marks" },


    

  ];

  useEffect(() => {
    if (location.pathname === "/user-chatbot") {
      console.log("i am gis")
      setTabLocation(true)
    }
  }, [location])

  useEffect(() => {


    const popupTemplate = {
      title: "Property Info",
      content: `
      <table style="width: 100%; border-collapse: collapse; text-align: left;">
        <tr>
          <th style="border: 1px solid #ddd; padding: 8px;">Field</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Value</th>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px;"><b>Area (Sq m):</b></td>
          <td style="border: 1px solid #ddd; padding: 8px;">{area}</td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px;"><b>Ulb Code:</b></td>
          <td style="border: 1px solid #ddd; padding: 8px;">{ulbcode}</td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px;"><b>Ulb Name:</b></td>
          <td style="border: 1px solid #ddd; padding: 8px;">{ulbname}</td>
        </tr>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px;"><b>Parcel No:</b></td>
          <td style="border: 1px solid #ddd; padding: 8px;">{parcelno}</td>
        </tr>
      </table>
    `
    };


//definitionExpression: filterExpr,
    
    // Group 1: MP State, MP District, MP Tehsil
    const group1 = new GroupLayer({
      title: "Administrative Boundaries",
      layers: [
        new FeatureLayer({ url: layerUrls[0].url, title: layerUrls[0].title }),
        new FeatureLayer({ url: layerUrls[1].url, title: layerUrls[1].title, visible: false }),
        new FeatureLayer({ url: layerUrls[2].url, title: layerUrls[2].title }),
        new FeatureLayer({ url: layerUrls[3].url, title: layerUrls[3].title, visible: true }),
        new FeatureLayer({ url: layerUrls[4].url, title: layerUrls[4].title, visible: true }),
        new FeatureLayer({ url: layerUrls[5].url, title: layerUrls[5].title, visible: true }),
        new FeatureLayer({ url: layerUrls[6].url, title: layerUrls[6].title, visible: true }),
       
      ]
    });

    // Group 2: Property
    const group2 = new GroupLayer({
      title: "Property",
      layers: [
        new FeatureLayer({ url: layerUrls[7].url, title: layerUrls[7].title, popupTemplate }),
        new FeatureLayer({ url: layerUrls[8].url, title: layerUrls[8].title }),
        new FeatureLayer({ url: layerUrls[9].url, title: layerUrls[9].title,visible: false }),
     
     
      ]

    });
    const map = new Map({
      basemap: 'topo-vector',
      layers: [group2, group1]

    });

    // const graphicsLayer = new GraphicsLayer();
    // map.add(graphicsLayer);

    const mapView = new MapView({
      container: mapRef.current,
      map: map,
      center: [78.746567, 23.834030],
      zoom: 6,
    });

    //LayerList

    mapView.when(() => {
      const layerList = new LayerList({ view: mapView });
      const layerListExpand = new Expand({
        view: mapView,
        content: layerList,
        expanded: isLayerListExpanded
      });
      mapView.ui.add(layerListExpand, "top-right");
      setView(mapView);
      if (onViewReady) {
        onViewReady(mapView);
      }
    });



    const homeWidget = new Home({ view: mapView });
    mapView.ui.add(homeWidget, "top-left");

    const scaleBar = new ScaleBar({ view: mapView, unit: "metric" });
    mapView.ui.add(scaleBar, { position: "bottom-right" });

    const basemapGallery = new BasemapGallery({ view: mapView });
    const basemapGalleryExpand = new Expand({ view: mapView, content: basemapGallery });
    mapView.ui.add(basemapGalleryExpand, { position: "top-left" });

    const locateWidget = new Locate({
      view: mapView,
      graphic: new Graphic({
        symbol: { type: "simple-marker" }
      })
    });
    mapView.ui.add(locateWidget, "top-left");



    return () => {
      if (mapView) {
        mapView.destroy();
      }
    };
  }, [isLayerListExpanded]);

  const Bufferlayers = [
    { name: "Properties", id: 14, outFields: ["ulbname ", "area", "districtname"] },
    { name: "Plot Building Structure", id: 15, outFields: ["ulb_cd ", "area"] },
    { name: "Important Land Marks", id: 79, outFields: ["type", " ulb_cd"] },

  ]




  useEffect(() => {
  //zoomToDistrict("Bhopal");

    const handleResize = () => {
      setIsScreenSize1(window.innerWidth <= 991)
    };

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const calculatedHeight = useMemo(() => {
    const hasFeatureTableData = setFeatureTable?.length > 0;

    // New condition: If isByDefaultActive is true and currentStageValue !== 2
    if (isWidth && isByDefaultActive && currentStageValue !== 2) {
      return "calc(100vh - 78px)"; // Adjust height as needed
    }

    if (isScreenSize1) {
      return tabLocation === "/user-chatbot" ? "calc(100vh - 240px)" : "calc(80vh - 78px)";
    }

    if (tabLocation) {
      return "calc(100vh - 78px)";
    }

    if (isDrag) {
      return "0px";
    }

    if (isWidth) {
      return hasFeatureTableData ? "calc(100vh - 285px)" : "calc(100vh - 78px)";
    }

    if (isWidth && currentStageValue === 1) {
      return "calc(100vh - 78px)"
    }

    // New condition: if isWidth is false, hasFeatureTableData is true, and currentStageValue === 2
    if (!isWidth && hasFeatureTableData && currentStageValue === 2) {
      return "calc(100vh - 430px)";
    }

    if (!isWidth && hasFeatureTableData && isByDefaultActive) {
      return "calc(100vh - 250px)";
    }

    return "calc(100vh - 250px)"
  }, [tabLocation, isDrag, isWidth, setFeatureTable, currentStageValue, isScreenSize, isScreenSize1, isByDefaultActive]);



  



  const handleAccordian = (index) => {
    if (selectedBuffer === index) {
      dispatch(setSelectedBuffer(null));
      setIsDrag(true);
      setIsAccordian(null);
    } else {
      // Open the clicked accordion
      dispatch(setSelectedBuffer(index));
      setIsDrag(true);
      setIsAccordian(index);
    }
  };

  console.log("isAccordian", isAccordian)

  const downloadTableData = (features, layerName) => {
    if (!features || features.length === 0) {
      console.log("No data available to download.");
      return;
    }

    // Convert features to CSV format
    const csvHeaders = Object.keys(features[0]).join(","); // Extract headers
    const csvRows = features.map(row => Object.values(row).join(",")); // Convert rows to CSV format
    const csvContent = [csvHeaders, ...csvRows].join("\n");

    // Create a Blob and download link
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${layerName}_data.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const printTableData = (features, layerName) => {
    // Create a hidden iframe
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    // Generate the HTML content
    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>${layerName}</title>
          <style>
            @media print {
              @page { margin: 20px; }
            }
            body { 
              font-family: Arial, sans-serif; 
              padding: 20px;
            }
            h2 { 
              text-align: center; 
              margin-bottom: 20px;
            }
            table { 
              width: 100%; 
              border-collapse: collapse; 
              margin-top: 10px;
              page-break-inside: auto;
            }
            tr { 
              page-break-inside: avoid;
              page-break-after: auto;
            }
            th, td { 
              border: 1px solid black; 
              padding: 8px; 
              text-align: left;
            }
            th { 
              background-color: #f2f2f2;
            }
            @media print {
              th { 
                background-color: #f2f2f2 !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
            }
          </style>
        </head>
        <body>
          <h2>${layerName}</h2>
          <table>
            <thead>
              <tr>
                ${Object.keys(features[0]).map(key => `<th>${key}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${features.map(feature => `
                <tr>
                  ${Object.values(feature).map(value => `<td>${value ?? '-'}</td>`).join('')}
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    // Write content to iframe and print
    const iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(printContent);
    iframeDocument.close();

    // Wait for content to load before printing
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      // Remove iframe after printing
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  };





  return (
    <>
      <div
        ref={mapRef}
        style={{
          width: "100%",
          height: currentStageValue == 3 ? '' : calculatedHeight,
          overflow: "hidden",
        }}
      />

      {!isByDefaultActive && (
        <div className="position-relative">
          {location.pathname !== "/user-chatbot" && currentStageValue === 2 && setFeatureTable.length > 0 && (
            <div className={isDrag ? 'isDragdiv' : 'dragdiv'} type="button" onClick={handleDrag}>
              <div className={isDrag ? 'not-rotate' : 'is-rotate'}>
                <img src="img/drag.svg" alt='drag' height="12px" width="12px" />
              </div>
              <div>
                <h6 className="viewmoretitle">{isDrag ? "View less data" : "View more data"}</h6>
              </div>
            </div>
          )}

          {currentStageValue === 2 && setFeatureTable.length > 0 && (
            <h6 className="tabletitlefeature">Feature Data</h6>
          )}

          {setFeatureTable.length > 0 && currentStageValue === 2 && (
            <div className={`${isDrag ? (isWidth ? "table-isdrag isDragWidth" : "table-isdrag isDragActive") : "maptablediv collapsed table-isdrag"}`}>
              <div className="accordion accordion-flush" id="accordionFlushExample">
                {setFeatureTable.map((buffer, index) => {
                  const isOpen = selectedBuffer === index; 
                  return (
                    <div className="accordion-item" key={index}>
                      {/* Sticky Header with Buttons */}
                      <h2 className="accordion-header sticky-header" id={`flush-heading-${index}`}>
                        <div className="accordion-header-content">
                          <button
                            className={`accordion-button ${isOpen ? '' : 'collapsed'}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAccordian(index); 
                            }}
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse-${index}`}
                            aria-expanded={isOpen ? "true" : "false"}
                            aria-controls={`collapse-${index}`}
                          >
                            {buffer.layer} ({buffer.features.length})
                          </button>

                          {/* Download and Print Buttons */}
                          <div className="tabledownloaddiv">
                            <button
                              className="download-btn"
                              onClick={(e) => { e.stopPropagation(); printTableData(buffer.features, buffer.layer); }}
                            >
                              <img src="img/print.svg" alt="print" /> Print
                            </button>

                            <button
                              className="download-btn"
                              onClick={(e) => { e.stopPropagation(); downloadTableData(buffer.features, buffer.layer); }}
                            >
                              <img src="img/downloadtable.svg" alt="download" /> Download
                            </button>
                          </div>
                        </div>
                      </h2>

                      <div
                        id={`collapse-${index}`}
                        className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}
                        aria-labelledby={`flush-heading-${index}`}
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div className="accordion-body">
                          <Table bufferFeatures={buffer?.features} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}


        </div>
      )}
    </>
  );
};

export default MapAiComponent;
